import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TestModeBanner from '@/components/TestModeBanner';
import { useSignup } from '@/lib/SignupContext';

export default function Layout() {
  const { openSignup } = useSignup();
  const { pathname, hash } = useLocation();

  // Scroll to top on route change (or to hash if present)
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return (
    <div className="App relative overflow-x-clip">
      <TestModeBanner />
      <Header onOpenSignup={openSignup} />
      <main>
        <Outlet context={{ openSignup }} />
      </main>
      <Footer onOpenSignup={openSignup} />
      {/*
        The simplified public registration popup is rendered by SignupProvider
        itself, so every "Register" CTA across the site opens the same modal.
        The WhatsApp floating button has been removed per the latest amendment —
        we route users through the explicit Register / Book Consultation CTAs.
      */}
    </div>
  );
}
